export enum UserRole {
    COLABORADOR = 'Colaborador',
    GESTOR = 'Gestor',
    RH = 'Recursos Humanos',
    DIRETOR = 'Diretor',
    ADMIN = 'Admin'
}

export interface User {
    id: number;
    email: string;
    name: string;
    role: string;
    company: any;
    manager: string | null;
    is_active?: boolean;
    must_change_password?: boolean;
}

export interface LoginRequest {
    email: string;
    password: string;
}

/** Usuário na gestão do RH/Diretor (tela Colaboradores). */
export interface ManagedUser {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    must_change_password: boolean;
}

export interface AuthResponse {
    access_token: string;
    token_type: string;
    user: User;
}

export interface AuthContextType {
    user: User | null;
    token: string | null;
    isAuthenticated: boolean;
    login: (email: string, password: string) => Promise<void>;
    logout: () => void;
    updateUser: (user: User) => void;
} 